export const formatBirth = (val: string) => {
  // Split the original date string into day, month, and year parts
  const parts = val.split('/')

  // Rearrange the parts to form the desired format
  const rearrangedDate = parts[2] + parts[1] + parts[0]

  return rearrangedDate
}

export function isVietnamesePhoneNumberValid(number: string) {
  return /(((\+|)84)|0)(3|5|7|8|9)+([0-9]{8})\b/.test(number)
}

export const formatDate = (val: string) => {
  const date = val
  const convertedDate = date.replace(/-/g, '')
  return convertedDate
}
